import {
  styled,
  Divider,
  dividerClasses,
  Button,
  buttonClasses,
  typographyClasses,
} from '@mui/material';

export const classes = {
  buttonExpanded:
    'DashboardVariantV2CarrierHeaderExpandMoreDividerButton-expanded',
};

export const DashboardVariantV2CarrierHeaderExpandMoreDividerContainer = styled(
  Divider,
)({
  '&::before, &::after': {
    borderWidth: 'thick',
    transformBox: 'content-box',
    borderColor: '#d3d7dc',
  },

  [`& .${dividerClasses.wrapper}`]: {
    padding: 0,
  },
});

export const DashboardVariantV2CarrierHeaderExpandMoreDividerButton = styled(
  Button,
)(({ theme }) => ({
  ...theme.typography.body1,
  fontWeight: theme.typography.fontWeightMedium,
  borderColor: '#b0b1b3',
  padding: theme.spacing(0, 2),
  borderRadius: 20,
  backgroundColor: theme.palette.common.white,
  minWidth: 180,
  gap: theme.spacing(1),

  '&:hover': {
    backgroundColor: theme.palette.common.white,
  },

  [`& .${typographyClasses.root}`]: {
    minWidth: 87,
  },

  [`& .${buttonClasses.endIcon}`]: {
    transform: 'rotate(270deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.standard,
    }),
    margin: 0,
  },

  [`&.${classes.buttonExpanded} .${buttonClasses.endIcon}`]: {
    transform: 'rotate(90deg)',
  },
}));
